import React from 'react'

const Sucursales = () => {
   return (
      <>
      <div className="bg-latitud animated fadeIn" style={{"margin-bottom":"30px"}}>
			<div className="container section center white-text">
				<h5>
					<strong>Sucurasales</strong>
				</h5>
			</div>
		</div>
      <div className="row grey-text text-darken-1">
         <div className="col s12">
            <div className="col s12 m4 l4 x4">
               <h4 className=""><strong>Jujuy</strong></h4>
               <p>Av. Urquiza Nº 602, Perico. Jujuy, Argentina.</p>
               <p>Pedro del Portal 1249 - Barrio 23 de Agosto - Cerca de Ciudad Cultural. S.S. de Jujuy. Jujuy, Argentina.</p>
            </div>
            <div className="col s12 m4 l4 x4">
               <h4 className=""><strong>Salta</strong></h4>
               <p>Pueyrredón 1485, local 2. Salta Capital, Argentina.</p>
               <p><strong>SUMICLI</strong><br/>Alvarado Nº 973, Salta Capital. Argentina.</p>
            </div>
            <div className="col s12 m4 l4 x4" style={{"margin-top": "60px"}}>
               <p><strong>Las Lajitas</strong><br/>Av. San Martin Nº 475, Salta. Argentina</p>
               <p><strong>Rosario de Lerma</strong><br/>Av. 9 de Julio Nº140 (Oficina 2), Salta. Argentina</p>
            </div>
         </div>
      </div>
      <div className="row">
			<div className="col s12 m12">
            <iframe 
               src="https://www.google.com/maps/d/embed?mid=1ZaYO_fqjh2Up0gGQAC-FZNOi8zEEY_4w&ehbc=2E312F" 
               width="100%" 
               height="500px">
            </iframe>
         </div>
		</div>
      </>
   )
}

export default Sucursales;